/** @jsxImportSource @emotion/react */

import type { ElementType } from "react";
import { optionListCSS } from "./OptionList.css";
import { OptionListProvider } from "./OptionList.provider";
import type { OptionListProps } from "./OptionList.types";

export const OptionList = <E extends ElementType>({
  children,
  as,
  sx,
  className,
  popOver,
  value,
  values,
  setValue,
  setValues,
  native,
}: OptionListProps<E>) => {
  const Element = as || "ul";

  return (
    <OptionListProvider value={value} values={values} setValues={setValues} setValue={setValue}>
      <Element className={className} css={[optionListCSS({ popOver }), sx]} {...native}>
        {children}
      </Element>
    </OptionListProvider>
  );
};
